import { EventEmitter } from '@angular/core';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { ANALYSIS_PLAN_FOLDERABLE_MODAL_APP_CONFIG } from 'HypotheticalsApp/apps/analysis-plan-list-app/constants';
import { ASC } from 'NewAngular/constants/core.constants';
import { AnalysisPlansSortColumn } from 'HypotheticalsApp/enums/analysis-plan-common.enum';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { SavedAnalysisPlanListAppStateManager } from 'HypotheticalsApp/apps/analysis-plan-list-app/services/saved-analysis-plan-list-app-state-manager.service';
import { SavedAnalysisPlanFolderableCollectionListModalService } from 'HypotheticalsApp/services/saved-analysis-plan-folderable-collection-list-modal.service';
import { SelectedAnalysisPlanService } from 'HypotheticalsApp/services/selected-analysis-plan.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { ItemSelectionService } from 'NewAngular/services/item-selection.service';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/features/folders-shared/folderable-open-saved-modal/folderable-single-select-saved-modal.component";
import * as i2 from "../analysis-plan-select-saved-list-item/analysis-plan-select-saved-list-item.component";
function AnalysisPlanSingleSelectSavedModalComponent_ng_template_1_Template(rf, ctx) { }
function AnalysisPlanSingleSelectSavedModalComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-analysis-plan-select-saved-list-item", 3);
} if (rf & 2) {
    const folderable_r2 = ctx.folderable;
    const ancestorInfo_r3 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r2)("ancestorInfo", ancestorInfo_r3);
} }
export class AnalysisPlanSingleSelectSavedModalComponent {
    constructor() {
        this.selectionHandler = new EventEmitter();
        this.backHandler = new EventEmitter();
        this.cancelHandler = new EventEmitter();
        this.viewReady = new EventEmitter();
        this.showBackButton = false;
        this.AnalysisPlansSortColumn = AnalysisPlansSortColumn;
        this.SAVED_ITEM_COLUMN_CONFIG = {
            [AnalysisPlansSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [AnalysisPlansSortColumn.MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [AnalysisPlansSortColumn.OWNER_NAME]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.SAVED_ITEM_FILTER_DEFAULT = {
            owner: {
                me: true,
                shared_with_me: true,
            },
            page: 1,
            sortColumn: AnalysisPlansSortColumn.MODIFY_DATE,
            sortDirection: ASC,
            name: '',
            includeEmptyFolders: true,
        };
    }
    ngAfterViewInit() {
        this.viewReady.emit();
    }
}
AnalysisPlanSingleSelectSavedModalComponent.ɵfac = function AnalysisPlanSingleSelectSavedModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AnalysisPlanSingleSelectSavedModalComponent)(); };
AnalysisPlanSingleSelectSavedModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AnalysisPlanSingleSelectSavedModalComponent, selectors: [["ycn-analysis-plan-single-select-saved-modal"]], inputs: { showBackButton: "showBackButton" }, outputs: { selectionHandler: "selectionHandler", backHandler: "backHandler", cancelHandler: "cancelHandler", viewReady: "viewReady" }, standalone: false, features: [i0.ɵɵProvidersFeature([
            SavedAnalysisPlanFolderableCollectionListModalService,
            SelectedAnalysisPlanService,
            BulkActionSelectionService,
            FolderExpansionService,
            ItemSelectionService,
            {
                provide: FolderableCollectionServiceBase,
                useExisting: SavedAnalysisPlanFolderableCollectionListModalService,
            },
            {
                provide: SelectedFolderableService,
                useExisting: SelectedAnalysisPlanService,
            },
            {
                provide: AppStateManager,
                useExisting: SavedAnalysisPlanListAppStateManager,
            },
            { provide: FOLDERABLE_APP_CONFIG, useValue: ANALYSIS_PLAN_FOLDERABLE_MODAL_APP_CONFIG },
        ])], decls: 5, vars: 12, consts: [["emptyTemplate", ""], ["listItemFragment", ""], [3, "selectionHandler", "backHandler", "cancelHandler", "modalHeader", "columnConfig", "sortableColumns", "userPreferenceFilterKey", "filterDefault", "listItemFragment", "publicSharing", "userHasNoDataMessage", "loadingMessage", "loadingTestId", "showBackButton", "columnHeaderTrailingFragment"], [3, "folderable", "ancestorInfo"]], template: function AnalysisPlanSingleSelectSavedModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-folderable-single-select-saved-modal", 2);
        i0.ɵɵlistener("selectionHandler", function AnalysisPlanSingleSelectSavedModalComponent_Template_ycn_folderable_single_select_saved_modal_selectionHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectionHandler.emit($event)); })("backHandler", function AnalysisPlanSingleSelectSavedModalComponent_Template_ycn_folderable_single_select_saved_modal_backHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.backHandler.emit()); })("cancelHandler", function AnalysisPlanSingleSelectSavedModalComponent_Template_ycn_folderable_single_select_saved_modal_cancelHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.cancelHandler.emit()); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, AnalysisPlanSingleSelectSavedModalComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, AnalysisPlanSingleSelectSavedModalComponent_ng_template_3_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const emptyTemplate_r4 = i0.ɵɵreference(2);
        const listItemFragment_r5 = i0.ɵɵreference(4);
        i0.ɵɵproperty("modalHeader", "Select Interactive Analysis Plan")("columnConfig", ctx.SAVED_ITEM_COLUMN_CONFIG)("sortableColumns", ctx.AnalysisPlansSortColumn)("userPreferenceFilterKey", "analysis_plan_list_modal_filters")("filterDefault", ctx.SAVED_ITEM_FILTER_DEFAULT)("listItemFragment", listItemFragment_r5)("publicSharing", false)("userHasNoDataMessage", "Get Started.<br><span>Create a new Interactive Analysis Plan</span>")("loadingMessage", "Loading Interactive Analysis Plans...")("loadingTestId", "saved-analysis-plans-loading-symbol")("showBackButton", ctx.showBackButton)("columnHeaderTrailingFragment", emptyTemplate_r4);
    } }, dependencies: [i1.FolderableSingleSelectSavedModalComponent, i2.AnalysisPlanSelectSavedListItemComponent], encapsulation: 2 });
